import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import CargomaticCard from 'components/v2/card';
import EquipmentStore from 'stores/EquipmentStore';
import EquipmentItem from './equipments/EquipmentItem';
import AddEquipmentModal from './AddEquipmentModal';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import EquipmentActionCreators from '../../../actions/EquipmentActionCreators';

class EquipmentsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModal: false,
    };
  }

  componentDidMount() {
    EquipmentStore.addChangeListener(this.handleEquipmentStoreChange);
  }

  componentWillUnmount() {
    EquipmentStore.removeChangeListener(this.handleEquipmentStoreChange);
  }

  handleAddEquipment = () => {
    this.setState({ showAddModal: true });
  };

  handleEquipmentStoreChange = () => {
    const equipmentList = EquipmentStore.getEquipment();
    if (!equipmentList || equipmentList.length === 0) {
      return;
    }
    const lastIndex = equipmentList.length - 1;
    const equipment = equipmentList[lastIndex];
    const equipments = this.props.order.equipments || [];

    // equipment already added to the order
    if (equipments.map((eq) => eq._id).includes(equipment._id)) {
      return;
    }
    this.handleEquipmentSelect(equipment);
  };

  handleCreateEquipment = (equipment) =>
    EquipmentActionCreators.addEquipment(equipment);

  handleEquipmentSelect = (equipment) => {
    const equipments = this.props.order.equipments || [];
    // equipment already added to the order
    if (equipments.map((eq) => eq._id).includes(equipment._id)) {
      return;
    }
    OrdersActionCreators.addEquipmentToOrder(
      this.props.order._id,
      equipment._id,
    );
  };

  render() {
    const { order, shipments, t } = this.props;
    return (
      <CargomaticCard
        header={() => <h3 className="my-0">{t('EQUIPMENT_DETAILS')}</h3>}
      >
        <div className="flex flex-row px-2 pb-2 mb-3 text-sm font-bold border-b-2 border-solid text-grey-darker border-grey-light">
          <div className="flex-1 min-w-100px">{titleize(t('EQUIPMENT_ID'))}</div>
          <div className="flex-1 min-w-80px">{titleize(t('TYPE'))}</div>
          <div className="flex-1 min-w-80px">{titleize(t('SIZE', { count: 1 }))}</div>
          <div className="flex-1 min-w-80px">{titleize(t('DATE', { count: 2 }))}</div>
          <div className="flex-1">{titleize(t('ATTACHED_TO_SHIPMENT'))}</div>
          <div className="w-100px" />
        </div>
        <div className="mb-2">
          {order.equipments.map((eq, idx) => {
            return (
              <EquipmentItem
                key={eq.equipment_id + idx}
                order={order}
                shipments={shipments}
                equipment={eq}
              />
            );
          })}
        </div>
        <div className="w-full px-2">
          <button
            className="flex flex-row justify-center w-1/2 button button-hollow-green md:w-1/3 lg:w-1/4"
            onClick={() => this.handleAddEquipment()}
            data-testid="add-equipment-button"
          >
            <i className="mr-2 fa fa-plus" />
            {t('EQUIPMENT')}
          </button>
        </div>
        {this.state.showAddModal && (
          <AddEquipmentModal
            show={this.state.showAddModal}
            onClose={() => this.setState({ showAddModal: false })}
            onCreateEquipment={this.handleCreateEquipment}
            onEquipmentSelect={this.handleEquipmentSelect}
          />
        )}
      </CargomaticCard>
    );
  }
}

EquipmentsList.propTypes = {
  order: PropTypes.object,
};

export default withTranslation()(EquipmentsList);